module.exports = __webpack_public_path__ + "img/destination_serengeti_ln.9ebefa23.jpg";